<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/twyjE/tc-custom/9781429923231.jpg?1735615332175" alt="This image is the cover for the book Raiders from the North"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raiders from the North
      </h1>
      <p class="bookDescription body article font2">
        <b>A boy emperor comes of age amid bloody conflict in this epic medieval series chronicling the rise and fall of Central Asia’s powerful Mogul dynasties.</b><br/><br/>It is 1494 when the ruler of Ferghana dies in an extraordinary accident. His only son, Babur, faces a seemingly impossible challenge. Babur is determined to live up to the example of his legendary ancestor, Tamburlaine, whose conquests transformed civilization from Delhi to the Mediterranean. But Babur is dangerously young to inherit a kingdom.<br/><br/>Before Babur can summon enough warlords to declare him the rightful king, plots against his crown, even his life, are hatching. And soon, he will discover that even the bravest leader can be betrayed. With wise advisers and courageous warriors by his side, Babur sets out to establish an empire in India, but every step of his journey is fraught with danger.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Rutherford
      </h2>
      
      <p class="authorDescription body article"><P>ALEX RUTHERFORD is the pen name for Diana Preston and her husband, Michael, whose nonfiction has been awarded the Los Angeles Times Science and Technology Prize and been praised worldwide. They have written seven books including <I>Cleopatra</I>, <I>Taj Mahal</I>, and <I>Before the Fallout</I>. They live in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St.Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b121df4